import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-slaver",
  "use": "icon-slaver-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-slaver\"><path d=\"M544 704h64a32 32 0 0 1 32 32v192a32 32 0 0 1-32 32h-192a32 32 0 0 1-32-32v-192a32 32 0 0 1 32-32h64V576H315.968a128.64 128.64 0 0 1-113.216 95.552L192 672A128 128 0 1 1 315.968 512H480V380.8a160.128 160.128 0 0 1-127.68-146.304L352 224a160 160 0 0 1 320 0 160.128 160.128 0 0 1-128 156.672V512H832a32 32 0 0 1 31.488 26.24l0.512 5.76V704h64a32 32 0 0 1 31.488 26.24l0.512 5.76v192a32 32 0 0 1-32 32h-192a32 32 0 0 1-32-32v-192a32 32 0 0 1 32-32h64V576h-256v128z m352 64h-128v128h128v-128z m-320 0H448v128h128v-128zM192 480a64 64 0 0 0-64 64c0 35.392 28.608 64 62.464 64l7.744-0.32A64 64 0 0 0 192 480zM512 128a96 96 0 0 0-1.152 192l8.32-0.256A96.064 96.064 0 0 0 512 128z\" p-id=\"8683\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/slaver.svg
// module id = hajP
// module chunks = 77